import { gql } from "@apollo/client";

const STRIPE_WEBHOOK_INFORMATION = gql`
  subscription stripeWebhook {
    stripeWebhook {
      stripe_subscription_status
      plans
      new_plan
      new_plan_status
      currentCount
      currentDeletedCount
      maxCount
    }
  }
`;

export default STRIPE_WEBHOOK_INFORMATION;
